import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'

import { INVERSION_PAGE_TYPES } from '../constants'
import { useInversionContext } from '../context/InversionContext'

export const useInversionData = () => {
  const { inversionData } = useInversionContext()
  const { appData } = useAppDataContext()
  const { pageType = '' } = appData?.page ?? {}

  let { inversionItems }: any = []
  if (pageType.includes(INVERSION_PAGE_TYPES.stores)) {
    inversionItems = inversionData?.storeList?.items
  } else if (pageType.includes(INVERSION_PAGE_TYPES.communities)) {
    inversionItems = inversionData?.communitiesList?.items
  } else if (pageType.includes(INVERSION_PAGE_TYPES.services)) {
    inversionItems = inversionData?.cityServicesResidentialList?.items
  }

  return inversionItems
}
